module.exports = __webpack_public_path__ + "media/application/images/header/globe-f98adaf9d250bfaa1ad1fd09b334f3fa.svg";